"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CurrentProjectsCard = _interopRequireDefault(require("./CurrentProjectsCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _CurrentProjectsCard.default;
exports.default = _default;